import moment from "moment";
import React, { useState } from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import Flatpickr from "react-flatpickr";

function UncontrolledDropDown({ direction = "down", handleValue, ...args }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [cutumDateRange, setCutumDateRange] = useState(null);

  let isSelected = false;

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <React.Fragment>
      <UncontrolledDropdown
        style={{
          position: "static",
          display: "inline-block"
        }}
        isOpen={dropdownOpen}
        toggle={() => {
          if (isSelected) {
            if (dropdownOpen === false) {
              setDropdownOpen(true);
            }
          } else {
            setDropdownOpen((preState) => !preState);
          }
        }}
        direction={direction}
      >
        <DropdownToggle
          className="btn-icon-only text-light"
          href="#pablo"
          role="button"
          color=""
          onClick={(e) => e.preventDefault()}
        >
          <i
            className="fas fa-ellipsis-v"
            style={{
              color: "black"
            }}
          />
        </DropdownToggle>
        <DropdownMenu
          {...args}
          right
          positionFixed
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DropdownItem
            onClick={(e) => {
              isSelected = true;
              e.stopPropagation();
              handleValue(
                moment.utc(moment().startOf("day")).format(),
                moment.utc(moment().endOf("day")).format()
              );
              setDropdownOpen(false);
              if (cutumDateRange) {
                setCutumDateRange(null);
              }
            }}
          >
            Today
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              isSelected = true;
              handleValue(
                moment.utc(moment().subtract(1, "month").startOf("day").format()).format(),
                moment.utc(moment().endOf("day")).format()
              );
              setDropdownOpen(false);
              if (cutumDateRange) {
                setCutumDateRange(null);
              }
            }}
          >
            Last Month
          </DropdownItem>

          <DropdownItem
            onClick={() => {
              isSelected = true;
              handleValue(
                moment.utc(moment().subtract(6, "month").startOf("day").format()).format(),
                moment.utc(moment().endOf("day")).format()
              );
              setDropdownOpen(false);
              if (cutumDateRange) {
                setCutumDateRange(null);
              }
            }}
          >
            Last 6 Month
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              isSelected = true;
              handleValue(
                moment.utc(moment().subtract(1, "year").startOf("day").format()).format(),
                moment.utc(moment().endOf("day")).format()
              );
              setDropdownOpen(false);
              if (cutumDateRange) {
                setCutumDateRange(null);
              }
            }}
          >
            Last Year
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              isSelected = true;
              handleValue("", "");
              setDropdownOpen(false);
              if (cutumDateRange) {
                setCutumDateRange(null);
              }
            }}
          >
            All
          </DropdownItem>
          <DropdownItem
            toggle={false}
            onClick={(e) => {
              isSelected = true;
              e.stopPropagation();
            }}
          >
            <Flatpickr
              required={true}
              value={cutumDateRange}
              options={{
                mode: "range",
                dateFormat: "m-d-Y",
                disableMobile: true,
                allowInput: true,
                position: "below right",

                onClose: (selectedDates) => {
                  if (selectedDates?.length === 2) {
                    setCutumDateRange(selectedDates);
                    handleValue(
                      moment.utc(moment(selectedDates[0]).startOf("day").format()).format(),
                      moment.utc(moment(selectedDates[1]).endOf("day").format()).format()
                    );
                  }
                  setDropdownOpen(false);
                }
              }}
              onChange={(e) => {
                isSelected = true;
              }}
              className="flatpickr datetimepicker form-control"
              placeholder="MM-DD-YYYY"
            />
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </React.Fragment>
  );
}

export default UncontrolledDropDown;
